

























import {CbcMixin} from "@/modules/cbc/mixins";
import {
	ConstituentEntity,
	ConstituentEntityCreateRequest,
	Organisation,
	UltimateParentEntityRoleEnum
} from "@/modules/cbc/models";
import _ from "lodash";
import {Component, Emit, Mixins, Prop} from "vue-property-decorator";

@Component({
	components: {}
})
export default class ConstituentEntityListComponent extends Mixins(CbcMixin) {
	@Prop()
	public readonly constituentEntities!: ConstituentEntity[];
	public headers: any[] = [
		{
			text: "Organisation",
			value: "organisation.name",
			align: "start"
		},
		{
			text: "TIN",
			value: "organisation.tin.tin",
			align: "start"
		},
		{
			text: "Role",
			value: "role",
			align: "start"
		}
	];

	@Emit("create")
	public onCreate() {
		return {
			reportId: this.$route.params["reportId"],
			constituentEntity: {} as ConstituentEntity
		} as ConstituentEntityCreateRequest
	}

	@Emit("get-constituent-entity")
	public onClickRow(row: ConstituentEntity) {
		return row;
	}

	public onGetNameUltimateParentEntityRole(ultimateParentEntityRole: UltimateParentEntityRoleEnum): string | undefined {
		if (!_.isUndefined(ultimateParentEntityRole))
			return this.ultimateParentEntityRoles.find(x => x.id === ultimateParentEntityRole)!.name!;
		return "";
	}
}
